(function($) {
    $(() => {
        if (!algolia_localize.page_settings.render_custom_blogs) {
            return;
        }

        const searchClient = algoliasearch(algolia_localize.app_id, algolia_localize.search_key);
        let sections = {
            type: 'blogs',
            title: 'Blogs',
            sources: ['https-asetek-com'],
            number_of_hits_per_page_default: 3,
            number_of_hits_per_page_filtered_state: 3
        };

        let global_index_name = 'asetek-live';

        let search;

        const monthNames = [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sept',
            'Oct',
            'Nov',
            'Dec'
        ];

        function getDate(date) {
            if (date == undefined) {
                var date = new Date();
            }
            return (
                (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) +
                ' ' +
                monthNames[date.getMonth()] +
                ', ' +
                date.getFullYear()
            );
        }

        function template(item, type, index) {
            let template;

            var featured_image =
                item['featured_image'] ||
                algolia_localize.plugin_url + 'assets/img/placeholder_pic.png';

            const date = getDate(new Date(item['date']));

            template = `<div class="col-lg-4 col-md-5 col-12">
        <div class="tile tile--border p-relative match-h">
            <a class="p-absolute-0" href="${item['url']}">
           
            <div class="tile__bg" style="background-image: url('${featured_image}')">
            </div>
            <div class="tile__content">
                <div class="tile__content__categories">
                    ${item['blogs_category']?.map(
                        category => `
                      <span  class="category">
                        ${category.name}
                      </span>
                    `
                    )}
                </div>
                <div class="tile__content__logo">
                  <img src="${
                      algolia_localize.plugin_url
                  }/assets/img/mini_logo_grey.svg" alt="logo">
                    <p>
                        by ${item['author']} / ${date}
                    </p>
                </div>
                <div class="tile__content__wrapper">
                    <h5 class="tile__content__wrapper__title">
                      ${instantsearch.highlight({ attribute: 'title', hit: item })}
                    </h5>
                    
                </div>
            </div>
            <img class="tile__arrow" src="${
                algolia_localize.plugin_url
            }/assets/img/tile_arrow.svg" alt="tile_arrow">
        </div>
        </a>
    </div>`;

            template = `
        <div class="col-lg-4 col-md-6">  
          <a href="${item['url']}">
              <div class="card-blog">
                  <img class="card-blog__img" src="${featured_image}" alt="">
                  <div class="overlay"></div>
          
                  <p class="card-blog__text"> ${instantsearch.highlight({
                      attribute: 'title',
                      hit: item
                  })}</p>
                  <button class="button button--primary">read more</button>
              </div>    
          </a>
        </div>`;

            return template;
        }

        // Create the render function
        const renderHits = (renderOptions, isFirstRender) => {
            const { hits, widgetParams } = renderOptions;

            if (hits.length > 0) {
                $(`#${widgetParams.container.id}`)
                    .parent()
                    .removeClass('no--result');
                widgetParams.container.innerHTML = `
      ${hits.map(item => template(item, widgetParams.type, widgetParams.index)).join('')}
    `;
            } else {
                $(`#${widgetParams.container.id}`)
                    .parent()
                    .addClass('no--result');
                widgetParams.container.innerHTML = `<div class="col-md-12"><p class="no__results">${algolia_localize.translations.algolia_no_result_text_overwrite}</p></div>`;
            }

            $.fn.matchHeight._applyDataApi();
            $('.match-h').matchHeight({
                byRow: true,
                property: 'height',
                target: null,
                remove: false
            });
        };

        var hasTab = $.getUrlParameter('tab');

        if (hasTab != '' && hasTab != undefined) {
            $(`.js-category-item[data-tab="${hasTab}"]`).addClass('active');
        } else {
            $('.js-category-item[data-tab=""]').addClass('active');
        }

        $(sections).each(function(i, e) {
            var currentFacetFilters = [];
            currentFacetFilters.push([`type:${e.type}`]);

            if (e.type == 'blogs' && $('.front-page').length) {
                currentFacetFilters.push([`blogs_category.slug:simsports`]);
            }

            if (e.sources.length > 0) {
                currentFacetFilters.push(e.sources);
            }

            const customHits = instantsearch.connectors.connectHits(renderHits);

            var currentHitsPerPage = e.number_of_hits_per_page_default;
            if (hasTab != '' && hasTab != undefined) {
                currentHitsPerPage = e.number_of_hits_per_page_filtered_state;
                if (hasTab != e.title) {
                    $(`#${e.title}.js-section-result`).addClass('hidden');
                }
            }

            if (i == 0) {
                search = instantsearch({
                    indexName: global_index_name,
                    searchClient,
                    // routing: true,
                    routing: {
                        router: instantsearch.routers.history({
                            createURL({ qsModule, location, routeState }) {
                                const { origin, pathname, hash } = location;
                                const queryString = qsModule.stringify(routeState);

                                var currentTab = $.getUrlParameter('tab');
                                var hasTab = false;

                                if (currentTab != '' && currentTab != undefined) {
                                    hasTab = true;
                                }

                                // if (hasTab) {
                                //     if (queryString) {
                                //         return `${origin}${pathname}?tab=${currentTab}&${queryString}`;
                                //     } else {
                                //         return `${origin}${pathname}?tab=${currentTab}`;
                                //     }
                                // } else {
                                //     if (queryString) {
                                //         return `${origin}${pathname}?${queryString}`;
                                //     } else {
                                //         return `${origin}${pathname}`;
                                //     }
                                // }
                            },
                            stateMapping: instantsearch.stateMappings.simple()
                        })
                    },
                    searchFunction(helper) {
                        if (helper.state.query == '') {
                            helper.setQueryParameter('filters', 'show_default:true');
                            helper.search();
                        } else {
                            helper.setQueryParameter(
                                'filters',
                                'show_default:true OR show_default:false'
                            );
                            helper.search();
                        }
                    }
                });

                search.on('render', () => {
                    $('.js-section-result').animate({ opacity: 1 });
                });
            }

            search.addWidgets([
                instantsearch.widgets
                    .index({ indexName: global_index_name, indexId: 'search_' + e.type })
                    .addWidgets([
                        customHits({
                            container: document.querySelector(`#section_${i}_hits`),
                            type: e.type,
                            index: i
                        }),
                        instantsearch.widgets.configure({
                            hitsPerPage: currentHitsPerPage,
                            facetFilters: currentFacetFilters
                        })
                    ])
            ]);
        });

        search.start();
    });
})(jQuery);
